import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: _ctx.value,
    "allow-clear": "",
    multiple: false,
    placeholder: "请选择",
    "option-filter-prop": "title",
    onChange: _ctx.handleChange,
    onClear: _ctx.onClear,
    class: _normalizeClass(["w100", _ctx.class])
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: item.id,
          value: item.id,
          title: item.name
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["value", "title"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "onChange", "onClear", "class"]))
}